export default __webpack_public_path__ + "static/media/1-Cloudxier-Heavenlyblush-website-homepage.5b4c273a.jpg";